angular.module("rjmNg.common.api").factory "Password", [
  "$resource"
  "serviceUrl"
  (
    $resource
    serviceUrl
  ) ->

    defaultParams =
      withCredentials: true
      headers:
        Accept: "application/json"
        "Content-Type": "application/json"

    actions =
      reset: angular.extend {}, defaultParams,
        method: "POST"
      validate: angular.extend {}, defaultParams,
        method: "POST"
        url: serviceUrl("/resets/:userId/:resetToken")

    password = $resource(serviceUrl("/resets"), {}, actions)

    reset: (email, product) ->
      password.reset({email, product}).$promise

    validate: (userId, resetToken) ->
      password.validate({userId, resetToken}, {}).$promise

]
